(function () {
  'use strict';
  if (window.mpGalleryHoursInstalled) return;
  window.mpGalleryHoursInstalled = true;
  function update() {
    var parts;
    try { parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Africa/Casablanca', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date()); } catch (error) { return; }
    function value(type) { return parts.find(function (part) { return part.type === type; }).value; }
    var day = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].indexOf(value('weekday'));
    var minutes = Number(value('hour')) * 60 + Number(value('minute'));
    var openAt = day === 0 ? 660 : 600;
    var closeAt = day === 0 ? 840 : day === 6 ? 1080 : 1200;
    var open = minutes >= openAt && minutes < closeAt;
    document.querySelectorAll('[data-mp-gallery-status]').forEach(function (el) {
      var en = el.dataset.language === 'en';
      var text;
      if (open) text = (en ? 'Open today until ' : 'Ouvert aujourd’hui jusqu’à ') + Math.floor(closeAt / 60) + (en ? ':00' : 'h');
      else if (minutes < openAt) text = (en ? 'Opens today at ' : 'Ouvre aujourd’hui à ') + Math.floor(openAt / 60) + (en ? ':00' : 'h');
      else text = (en ? 'Closed · opens tomorrow at ' : 'Fermé · ouvre demain à ') + (day === 6 ? '11' : '10') + (en ? ':00' : 'h');
      el.textContent = text;
      el.classList.toggle('is-open', open);
    });
    document.querySelectorAll('[data-mpg-hours] [data-days]').forEach(function (el) { el.classList.toggle('is-today', el.dataset.days.split(',').includes(String(day))); });
  }
  update();
  setInterval(update, 60000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) update(); });
})();
